import { createSelector } from '@ngrx/store';

import { getUploaderState } from '../uploader/uploader.state';

export const getNavigationState = createSelector(getUploaderState, (state) => state.navigation);

export const getActiveView = createSelector(getNavigationState, (state) => state.activeView);
